// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__U9GXO","title":"Contact_title__+l+yk"};